"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundVideo = exports.BackgroundImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BackgroundImage = function (_a) {
    var src = _a.src;
    return (0, jsx_runtime_1.jsx)("img", { src: src, alt: "", className: "object-fit-cover absolute-fill" });
};
exports.BackgroundImage = BackgroundImage;
var BackgroundVideo = function (_a) {
    var src = _a.src;
    return ((0, jsx_runtime_1.jsx)("video", __assign({ autoPlay: true, loop: true, muted: true, className: "object-fit-cover absolute-fill" }, { children: (0, jsx_runtime_1.jsx)("source", { src: src, type: "video/mp4" }) })));
};
exports.BackgroundVideo = BackgroundVideo;
